@if (isModal) {
    <div class="modal-header pt-3">
        <h4 class="modal-title fw-bold">{{title}}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dismiss()">
        </button>
    </div>
    <div class="modal-body pt-3">
       <ng-container [ngTemplateOutlet]="modalContent"></ng-container>
    </div>
    <div class="modal-footer pt-3">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="dismiss()">
            <span jhiTranslate="ok"></span>
        </button>
    </div>

} @else {
    <ng-container [ngTemplateOutlet]="modalContent"></ng-container>
}

<ng-template #modalContent>
        <nav>
            <ul class="nav nav-tabs">
                <li class="nav-item pe-1">
                    <a class="nav-link" jhiTranslate="ontology.variable-details.nav.detail"
                       [routerLink]="['details']" [routerLinkActive]="['active']" queryParamsHandling="merge"></a>
                </li>
                <li class="nav-item pe-1">
                    <a class="nav-link" jhiTranslate="ontology.variable-details.nav.valid-values"
                       [routerLink]="['valid-values/']" [routerLinkActive]="['active']" queryParamsHandling="merge"></a>
                </li>
            </ul>
        </nav>
        <div class="tab-content p-3">
            <router-outlet></router-outlet>
        </div>
</ng-template>
